<template>
  <form class="grid grid-cols-1 gap-10 lg:grid-cols-2">
    <div v-for="field in fields" :key="`uf${field.id}`">
      <component
        :is="field.component"
        :id="field.id"
        :label="field.label"
        :placeholder="field.placeholder"
        :required="field.required"
        :error="field.error"
        :options="field.options || []"
        :link="field.link || ''"
        v-model="field.value"
        @change="triggerSaveClientData(field)"
      />
    </div>
  </form>
</template>

<script>
import TextField from '@/components/Form/TextField';
import PhoneField from '@/components/Form/PhoneField';
import BooleanField from '@/components/Form/BooleanField.vue';
import useCheckout from '@/stores/Checkout';
import { computed } from 'vue';
import fieldValidator from '@/libraries/FieldValidator';

export default {
  name: 'CheckoutUserForm',
  components: {
    TextField,
    PhoneField,
    BooleanField
  },
  setup() {
    const { getFilteredUserFields, saveClientData } = useCheckout();

    let saveTimeout;
    const triggerSaveClientData = field => {
      if (field.value) {
        fieldValidator(field);
      }
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(() => {
        saveClientData();
      }, 50);
    };

    return {
      fields: computed(() => getFilteredUserFields()),
      triggerSaveClientData
    };
  }
};
</script>
